'use es6';

export const MEETING_SOURCE_CALENDAR_EVENT = 'CALENDAR_EVENT';
export const MEETING_SOURCE_EMAIL = 'EMAIL';
export const MEETING_SOURCE_PARAM = 'ms';
export const LEGACY_MEETING_SOURCE_PARAM = 'meetingSource';
export const LEGACY_MEETING_CHANGE_ID_PARAM = 'meetingChangeId';
export const RESCHEDULE_PARAM = 'rescheduleId';
export const CANCEL_PARAM = 'cancelId';
export const LEGACY_RESCHEDULE_PARAM = 'reschedule';
export const LEGACY_CANCEL_PARAM = 'cancel';